import React from 'react';
import { Home, Phone, Calendar, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import { useAppointment } from '../context/AppointmentContext';

const NotFound = () => {
  const { openAppointmentModal } = useAppointment();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="py-24 bg-gradient-to-br from-[#1B1B3A] via-[#2D2D4A] to-[#1B1B3A] text-white min-h-[60vh] flex items-center">
          <div className="container mx-auto px-4 text-center">
            <div className="max-w-2xl mx-auto">
              <div className="text-8xl font-bold text-[#E63946] mb-4">404</div>
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Page Not Found
              </h1>
              <p className="text-xl text-gray-300 mb-10">
                The page you're looking for doesn't exist or may have been moved.
                Let us help you find what you need.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <Button
                  size="lg"
                  className="bg-[#E63946] hover:bg-[#D32F3D] text-white font-semibold px-8"
                  onClick={() => window.location.href = '/'}
                >
                  <Home className="mr-2 h-5 w-5" />
                  Back to Home
                </Button>
                <Button
                  size="lg"
                  className="bg-[#20B2AA] hover:bg-[#1B9E97] text-white font-semibold px-8"
                  onClick={openAppointmentModal}
                >
                  <Calendar className="mr-2 h-5 w-5" />
                  Schedule Consultation
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-2 border-white text-white hover:bg-white/10 font-semibold px-8"
                  asChild
                >
                  <a href="tel:+14043552728">
                    <Phone className="mr-2 h-5 w-5" />
                    Call (404) 355-2728
                  </a>
                </Button>
              </div>

              <div className="grid sm:grid-cols-3 gap-4 text-sm text-gray-400">
                <a href="/" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> Home
                </a>
                <a href="/blog" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> Blog
                </a>
                <a href="/faq" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> FAQ
                </a>
                <a href="/meet-the-doctor" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> Meet the Doctor
                </a>
                <a href="/for-attorneys" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> For Attorneys
                </a>
                <a href="/for-chiropractors" className="hover:text-[#20B2AA] transition-colors flex items-center justify-center gap-1">
                  <ArrowLeft className="h-4 w-4" /> For Chiropractors
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
